import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { useAccountStateContext } from 'Components/Accounts/AccountContext';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import Tab from '@material-ui/core/Tab';
import { pickImplementation } from 'Helpers/Affordances';
import fr from 'facet-rest';
import relationships from 'Consts/Relationships';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { noop } from 'Helpers/PropTypes';
import Account from './SubTabs/Account';
import Performance from './SubTabs/Performance';
import InvestmentsSkeleton from './InvestmentsSkeleton';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  tabs: {
    '& > .MuiTabs-indicator': {
      backgroundColor: theme.palette.facet,
    },
  },
});

function InvestmentsView({ classes }) {
  const { accountCollection } = useAccountStateContext();
  const { householdResource } = useSimpleHousehold();
  const [activeIndex, setActiveIndex] = React.useState(0);

  if (!accountCollection) {
    return (
      <div className={classes.root}>
        <div className={classes.tabPanel}>
          <InvestmentsSkeleton classes={classes} />
        </div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <TabContext value={activeIndex}>
        <TabList
          className={classes.tabs}
          variant="scrollable"
          indicatorColor="primary"
          textColor="primary"
          value={activeIndex}
          onChange={(event, newValue) => setActiveIndex(newValue)}
        >
          <Tab label="Accounts" color="primary" />
          {pickImplementation(householdResource, {
            [fr.relationships.investmentsPerformance.name]: (
              <Tab label="Performance" color="primary" />
            ),
            [relationships.default]: noop, // we're using noop opposed to null because of an issue in the the mui lab tab panel
          })}
        </TabList>
        <TabPanel className={classes.tabPanel} value={0}>
          <Account />
        </TabPanel>
        {pickImplementation(householdResource, {
          [fr.relationships.investmentsPerformance.name]: (
            <TabPanel
              style={{ height: '100%' }}
              className={classes.tabPanel}
              value={1}
            >
              <Performance />
            </TabPanel>
          ),
          [relationships.default]: noop, // we're using noop opposed to null because of an issue in the the mui lab tab panel
        })}
      </TabContext>
    </div>
  );
}

InvestmentsView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(InvestmentsView);
